import { HTMLProps, RefCallback } from 'react'
import ReactSlider from 'react-slider'
import { EventUnionType } from './MortgageCalculator'

export interface SliderEvent {
  target: { value: string }
  id: string
  type: 'customEvent'
}

interface Props {
  type:
  | 'propertyValue'
  | 'downPayment'
  | 'monthlyFee'
  | 'yearlyOperatingCost'
  | 'personalLoanAmount'
  value: number
  onChangeHandler: (event: EventUnionType) => void
  min: number
  max: number
  label: string
  step: number
  marks?: number | boolean | readonly number[] | undefined
}

function secureRandomInt(min: number, max: number) {
  const range = max - min + 1
  const randomBytes = new Uint32Array(1)
  window.crypto.getRandomValues(randomBytes)
  const randomNumber = randomBytes[0] / (0xffffffff + 1)
  return Math.floor(randomNumber * range) + min
}

function CustomSlider({
  type = 'propertyValue',
  value,
  onChangeHandler,
  min,
  max,
  label,
  step,
  marks,
}: Readonly<Props>) {
  // This is to make the event fit the type ChangeEvent
  function handleChange(sliderValue: number) {
    onChangeHandler({
      target: { value: sliderValue.toString() },
      id: type,
      type: 'customEvent',
    })
  }

  interface HTMLPropsWithRefCallback<T> extends HTMLProps<T> {
    ref: RefCallback<T>
  }

  function renderMarkHandler(props: HTMLPropsWithRefCallback<HTMLSpanElement>) {
    if (props.style?.left && +props.style?.left > 5) {
      return <span {...props} key={secureRandomInt(0, 999)} />
    }
    return <span className="hidden" key={secureRandomInt(0, 999)} />
  }

  // Handle edge cases where max is 0
  let maxValue = max
  if (label === 'Kontantinsats' && max === 0) maxValue = value

  return (
    <ReactSlider
      ariaLabel={`Slider - ${label}`}
      value={value}
      min={min}
      max={maxValue}
      onChange={handleChange}
      step={step}
      marks={marks}
      renderMark={renderMarkHandler}
      className="mt-6 h-7 w-full text-black"
      thumbClassName="border-2 w-[1.4rem] h-[1.4rem] top-[-9px] left-4 bg-white rounded-full focus:ring focus:ring-focus_blue focus:outline-none"
      // pca-track is for styling the track described in index.css
      trackClassName="h-1 bg-black pca-track"
      markClassName="w-1 h-8 bg-white after:content-['min'] ml-[7px] after:text-black after:relative after:top-3 after:-ml-3"
      renderThumb={(props: HTMLPropsWithRefCallback<HTMLDivElement>) => (
        <div {...props}></div>
      )}
    />
  )
}

export default CustomSlider
